import gql from "graphql-tag";

export const BUY_ITEM = gql`
  mutation buyItemStore($itemKey: String, $type: String) {
    buyItemStore(itemKey: $itemKey, type: $type) {
      id
      tooth
      purchases {
        id
        itemKey
        price
        type
      }
    }
  }
`;

export const GET_SEASONAL_SALES_ADMIN = gql`
  {
    seasonalSalesAdmin {
      season
      isCurrent
      avatarSales
      diceSales
      revenue
      avatars {
        file
        itemKey
        rarity
        price
        portrait
        sales
        revenue
      }
      dice {
        id
        color
        background
        price
        sales
        revenue
      }
    }
  }
`;

export const GET_USER_PURCHASES = gql`
  {
    me {
      id
      purchases {
        id
        itemKey
        price
        type
      }
    }
  }
`;
